import React from 'react';
import GettingStarted from './components/GettingStarted';
import FilerTypes from './components/FilerTypes';
import FilerListing from './FilerListing';
import RecentlyOrganized from './components/RecentlyOrganized';
import BankDepositorySetUp from './components/GettingStarted/components/BankDepositorySetUp';

const routes = [
  {
    path: '/Filers/GettingStarted',
    renderer: (params = {}): JSX.Element => <GettingStarted {...params} />,
  },
  {
    path: '/Filers/FilerTypes',
    renderer: (params = {}): JSX.Element => <FilerTypes {...params} />,
  },
  {
    path: '/FilerListing',
    renderer: (params = {}): JSX.Element => <FilerListing {...params} />,
  },
  {
    path: '/Filers/FilerListing',
    renderer: (params = {}): JSX.Element => <FilerListing {...params} />,
  },
  {
    path: '/Filers/RecentlyOrganized',
    renderer: (params = {}): JSX.Element => <RecentlyOrganized {...params} />,
  },
  {
    path: '/Filers/BankDepository',
    renderer: (params = {}): JSX.Element => <BankDepositorySetUp {...params} />,
  }
];

export default routes;
